import { IDichVuThongTin } from "../../../model/respone/dich-vu/IDichVuThongTin";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDichVuThongTinActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDichVuThongTin[],
  LOAD_ERRR: "",

  SAVE_START: {} as IDichVuThongTin,
  SAVE_SUCCESS: {} as IDichVuThongTin,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  SHOW_EDIT_MODAL: {} as undefined | IDichVuThongTin,
  CLOSE_EDIT_MODAL: undefined,

  SELECTED_ID: [] as number[],
  SELECTED_START: {} as IDichVuThongTin,
};
export const eDichVuThongTinActionIds = generateActionTypeIds(
  eDichVuThongTinActionsObj,
  "DICH_VU_THONG_TIN"
);
export type IDichVuThongTinActionTypes = IGenericActionType<
  typeof eDichVuThongTinActionsObj,
  "DICH_VU_THONG_TIN"
>;
